export default __webpack_public_path__ + "static/media/check-in with text.7dc4a860.png";